export default __webpack_public_path__ + "static/media/loading.de49ec41.gif";